angular.module('tgaAdmin')
  .controller('NotificationsController', [
    '$scope', '$window', '$uibModalInstance', '$uibModalStack', 'notificationService', 'reportService',
    function (
      $scope, $window, $uibModalInstance, $uibModalStack, notificationService, reportService,
    ) {
      $scope.data = {
        alerts: [],
        closeButton: true,
      };

      $scope.viewmodel = {
        messages: [],
      };

      $scope.initialize = function () {
        $scope.loading = true;

        notificationService.getNotifications().then((messages) => {
          $scope.viewmodel.messages = messages;
          $scope.loading = false;
        });
      };

      $scope.actions = {
        handleMessage(message) {

          switch (message.action) {
            case 'report':
              // eslint-disable-next-line no-constant-condition
              if (message.read) {
                reportService.getReport(message.action_id).then((report) => {
                  $window.open(report.url);
                });
              }

              notificationService.markRead(message.notification_id).then((messages) => {
                $scope.viewmodel.messages = messages;
              });
              break;
            default:
              break;
          }
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        close() {
          $uibModalInstance.dismiss();
        },
      };

      $scope.initialize();
    },
  ]);
